export type DesktopOs = 'windows' | 'linux';
export interface DesktopInstaller {
  version?: string;
  platform: DesktopOs;
  format: 'exe' | 'deb' | 'rpm' | 'AppImage';
  arch: 'x64' | 'arm64';
  fileName: string;
  url: string;
  size: number;
  sha256: string;
}
export interface DesktopRelease { version: string; files: DesktopInstaller[] }

export function desktopOs(userAgent: string): DesktopOs | null {
  if (/Android|iPhone|iPad|iPod|Macintosh|Mobile/i.test(userAgent)) return null;
  return /Windows NT/i.test(userAgent) ? 'windows' : /Linux|X11/i.test(userAgent) ? 'linux' : null;
}

/** Only published versioned files on this origin may become executable links. */
export function parseDesktopRelease(value: unknown): DesktopRelease {
  if (!value || typeof value !== 'object') throw new Error('Invalid release');
  const { version, files } = value as Record<string, unknown>;
  if (typeof version !== 'string' || !/^\d+\.\d+\.\d+$/.test(version) || !Array.isArray(files) || files.length > 12) throw new Error('Invalid release');
  const seen = new Set<string>();
  const parsed = files.map((file: unknown) => {
    if (!file || typeof file !== 'object') throw new Error('Invalid installer');
    const f = file as DesktopInstaller;
    const fileVersion = f.version ?? version;
    if (typeof fileVersion !== 'string' || !/^\d+\.\d+\.\d+$/.test(fileVersion)) throw new Error('Invalid installer version');
    if (!['x64','arm64'].includes(f.arch) || !['windows','linux'].includes(f.platform)
      || !(f.platform === 'windows' ? f.format === 'exe' : ['deb','rpm','AppImage'].includes(f.format))
      || typeof f.fileName !== 'string' || !/^Worki-[A-Za-z0-9.-]+$/.test(f.fileName)
      || !f.fileName.endsWith(`.${f.format}`) || !f.fileName.includes(fileVersion)
      || f.url !== `/downloads/${fileVersion}/${f.fileName}`
      || !Number.isSafeInteger(f.size) || f.size <= 0
      || typeof f.sha256 !== 'string' || !/^[a-f0-9]{64}$/.test(f.sha256)
      || seen.has(f.fileName) || seen.has(`${f.platform}:${f.arch}:${f.format}`)) throw new Error('Invalid installer');
    seen.add(f.fileName);seen.add(`${f.platform}:${f.arch}:${f.format}`);
    return { version:fileVersion,platform:f.platform,format:f.format,arch:f.arch,fileName:f.fileName,url:f.url,size:f.size,sha256:f.sha256 };
  });
  return {version,files:parsed};
}
